import { render, staticRenderFns } from "./ContentFeedFileList.vue?vue&type=template&id=35c7bd7b&"
import script from "./ContentFeedFileList.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedFileList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports